import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import styled from 'styled-components';

import { Action } from '@soluto-private/mx-asurion-ui-react';

import {
  useAnalytics,
  useInViewAnalytics,
} from '@service-initiation/shared-data-access-analytics';
import {
  LeftMainContentSection,
  LeftMainNavigationButtonContainer,
  MainContentContainer,
  PageContainer,
} from '@service-initiation/shared-ui-page-layout';
import { TranslationEntries } from '@service-initiation/tech-care-data-access-i18n';
import { Route } from '@service-initiation/tech-care-data-access-routing';
import {
  useCustomerDetailsConfirmedAtom,
  useCustomerDetailsValue,
  useLeadIdAtom,
  useUpdatedLeadIdAtom,
} from '@service-initiation/tech-care-data-access-store';
import { Layout } from '@service-initiation/tech-care-ui-layout';
import { StepTitle } from '@service-initiation/tech-care-ui-step-title';

const Container = styled.div`
  text-align: left;
  margin-bottom: 40px;
  transition: opacity 200ms linear;
`;

const ButtonContainer = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 30px;
`;

const TEXTS = TranslationEntries.Repairs.Cancellation.DoubleCheckPage;

export const CancelAppointmentPage = () => {
  const navigate = useNavigate();
  const customerDetails = useCustomerDetailsValue();
  const [leadId, setLeadId] = useLeadIdAtom();
  const [, setUpdatedLeadId] = useUpdatedLeadIdAtom();
  const [, setCustomerDetailsConfirmed] = useCustomerDetailsConfirmedAtom();
  const { dispatchClickEvent } = useAnalytics();
  const { ref } = useInViewAnalytics(
    'CancellationPage',
    {
      ...(customerDetails?.phoneNumber && {
        mdn: customerDetails?.phoneNumber,
      }),
      marketingCommunicationsOptIn:
        customerDetails?.agreeToEmailOffers || false,
    },
    {
      Email: customerDetails?.email || '',
    }
  );

  const { t } = useTranslation();

  return (
    <Layout>
      <PageContainer>
        <MainContentContainer>
          <LeftMainContentSection>
            <Container data-testid="cancellation-container" ref={ref}>
              <StepTitle title={t(TEXTS.Title)} />
              <ButtonContainer>
                <Action
                  onClick={() => {
                    dispatchClickEvent('CancellationPageConfirmClick', {
                      Cta: 'CancellationPageConfirmClick',
                    });
                    setLeadId(leadId);
                    setCustomerDetailsConfirmed(true);

                    navigate(Route.ConfirmCancel);
                  }}
                >
                  {t(TEXTS.Cancel)}
                </Action>
                <Action
                  onClick={() => {
                    dispatchClickEvent('CancellationPageKeepClick', {
                      Cta: 'CancellationPageKeepClick',
                    });
                    navigate(Route.Confirmation, { replace: true });
                  }}
                  variant="outline"
                >
                  {t(TEXTS.Keep)}
                </Action>
                <Action
                  onClick={() => {
                    dispatchClickEvent('CancellationPageRescheduleClick', {
                      Cta: 'CancellationPageRescheduleClick',
                    });
                    if (leadId) {
                      setLeadId(undefined);
                      setUpdatedLeadId(leadId);
                      setCustomerDetailsConfirmed(true);
                    }
                    navigate(Route.AppointmentTime, { replace: true });
                  }}
                  variant="flat"
                >
                  {t(TEXTS.Reschedule)}
                </Action>
              </ButtonContainer>
            </Container>
          </LeftMainContentSection>
          <LeftMainNavigationButtonContainer />
        </MainContentContainer>
      </PageContainer>
    </Layout>
  );
};
